import { render, staticRenderFns } from "./WizardFormStep.vue?vue&type=template&id=ffb486c0&"
import script from "./WizardFormStep.vue?vue&type=script&lang=ts&"
export * from "./WizardFormStep.vue?vue&type=script&lang=ts&"
import style0 from "./WizardFormStep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports